// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilePptTwoToneSvg from "@fishx/icons-svg/es/asn/FilePptTwoTone";
import FishxIcon from '../components/FishxIcon';

var FilePptTwoTone = function FilePptTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilePptTwoToneSvg
  }));
};

FilePptTwoTone.displayName = 'FilePptTwoTone';
export default React.forwardRef(FilePptTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FilePptTwoTone.js
// module id = 2733
// module chunks = 0